import { Module } from "vuex";

export const FeeTrackingKS: Module<any, any> = {
  state: {
    queryFeeTrackingKS: {
      company_ids: [],
      cpn_code: [],
      quarter: null,
      year: null,
      businessCpn: [],
      network_type: [],
      lic_number: [],
      fromDay: null,
      toDay: null,
      isCheckCpn: false,
      statuses: [],
    },
  },
  getters: {
    queryFeeTrackingKS: (state) => state.query,
  },
  mutations: {
    setqueryFeeTrackingKS(state, data) {
      state.queryflowdata = data;
    },
  },
  actions: {
    setqueryFeeTrackingKS(query) {
      query.commit("setqueryFeeTrackingKS");
    },
  },
};
